import { applicationApi } from "../../common/api";
import { Document } from "./types";

// Define a service using a base URL and expected endpoints
export const documentApi = applicationApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllDocument: builder.query<Document[], void>({
      query: () => `document`,
      providesTags: [{ type: "Documents", id: "LIST" }],
    }),
    getDocument: builder.query<Document, string>({
      query: (query) => `document/${query}`,
    }),
    createDocument: builder.mutation<Document, any>({
      query: (body) => ({
        url: "/document",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "Documents", id: "LIST" }],
    }),
    deleteDocument: builder.mutation<any, number>({
      query: (id) => ({
        url: `document/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Documents", id: "LIST" }],
    }),
    updateDocument: builder.mutation<Document, any>({
      query: (body) => ({
        url: "/document",
        method: "PATCH",
        body,
      }),
      invalidatesTags: [{ type: "Documents", id: "LIST" }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllDocumentQuery,
  useGetDocumentQuery,
  useCreateDocumentMutation,
  useDeleteDocumentMutation,
  useUpdateDocumentMutation,
} = documentApi;
